import request from "@/utils/api/helpers";
import { VENDOR_USER_TYPE, SUPPLIER_USER_TYPE } from "@/utils/userTypes";
import { getDynamicObjectRecords } from "@/api/dynamic/dynamicObjectNameApi";
import dynamicObjectMap from "@/utils/maps/dynamicObjectMap";

const baseUrl = "/auth";

export const loginUser = (data) =>
  request({
    url: baseUrl,
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    data,
  });

export const logoutUser = () =>
  request({
    url: `${baseUrl}/logout`,
  });

export const setToken = (token) => {
  window.localStorage.setItem("tuli_auth", token);
};

export const setUserType = (userType) => {
  window.localStorage.setItem("user_type", userType);
};

export const setUserID = (userID) => {
  window.localStorage.setItem("user_id", userID);
};

export const setUserLoginId = (userLoginId) => {
  window.localStorage.setItem("user_login_id", userLoginId);
};

export const getUserLoginId = () =>
  window.localStorage.getItem("user_login_id");

export const removeUserLoginId = () =>
  window.localStorage.removeItem("user_login_id");

export const getUserType = () => window.localStorage.getItem("user_type");

export const removeUserType = () =>
  window.localStorage.removeItem("user_type");

export const getToken = () => window.localStorage.getItem("tuli_auth");

export const setRoles = (roles) =>
  window.localStorage.setItem("roles", JSON.stringify(roles));

export const getRoles = () => {
  const roles = window.localStorage.getItem("roles");
  let userRoles = [];
  try {
    userRoles = JSON.parse(roles);
  } catch (error) {
    console.log(error);
  }

  return userRoles;
};

export const removeRoles = () => window.localStorage.removeItem("roles");

export const setPrecision = (precision) => {
  window.sessionStorage.setItem("tuli_precision", precision);
};

export const getPrecision = () =>
  window.sessionStorage.getItem("tuli_precision");

export const removePrecision = () =>
  window.sessionStorage.removeItem("tuli_precision");

export const removeToken = () => window.localStorage.removeItem("tuli_auth");

export const setDateFormat = (dateFormat) => {
  window.sessionStorage.setItem("date_format", dateFormat);
};

export const getDateFormat = () =>
  window.sessionStorage.getItem("date_format");

export const removeDateFormat = () =>
  window.sessionStorage.removeItem("date_format");

export const setCompany = (companyId) =>
  window.sessionStorage.setItem("company", companyId);

export const getCompany = () => window.sessionStorage.getItem("company");

export const removeCompany = () => window.sessionStorage.removeItem("company");

export const resetLocalStorage = () => {
  removeToken();
  removeUserType();
  removeUserLoginId();
  removeRoles();

  removeCompany();
  removePrecision();
  removeDateFormat();
};

export const getUserData = async (userType, userId) => {
  let objectName;

  switch (userType) {
    case VENDOR_USER_TYPE:
    case SUPPLIER_USER_TYPE:
      objectName = dynamicObjectMap.get("SupplierStaffObjectName");
      break;

    default:
      objectName = dynamicObjectMap.get("EmployeeObjectName");
      break;
  }

  return getDynamicObjectRecords(objectName, {
    userId,
    queryMode: "Deep"
  });
};
